import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert,
  AlertTitle,
} from "@mui/material";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { FaFilePdf } from "react-icons/fa";
import { useUserAuth } from "../../Context/userAuthContext";
import "../shared/modern-ui.css";

const UserProfile = () => {
  const [user, setUser] = useState({});
  const [userDetailsIsFilled, setUserDetailsIsFilled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false); // Dialog açma durumu
  const [loading, setLoading] = useState(false); // Silme işlemi sırasında yükleniyor durumu
  const { logout } = useUserAuth();
  const loginType = "user";

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(
          "https://kariyer.biyomed.net/api/users/getOneDetails",
          {
            withCredentials: true, // Cookie gönderimi için
          }
        );
        const res = await axios.get("https://kariyer.biyomed.net/api/users/getOne", {
          withCredentials: true, // Cookie gönderimi için
        });
        setUserDetailsIsFilled(true);
        setUser({ ...res.data.user, ...response.data.user });
      } catch (error) {
        console.error("Error fetching user:", error);
        setUserDetailsIsFilled(false);
      }
    };

    fetchUser();
  }, []);

  const handleDownload = (pdfData, fileName) => {
    if (pdfData && pdfData.startsWith("data:application/pdf;base64,")) {
      const base64Data = pdfData.split("base64,")[1]; // Base64 verisini ayıklama

      const pdfBlob = new Blob(
        [
          new Uint8Array(
            atob(base64Data)
              .split("")
              .map((c) => c.charCodeAt(0))
          ),
        ],
        { type: "application/pdf" }
      );
      const link = document.createElement("a");
      const url = URL.createObjectURL(pdfBlob);

      link.href = url;
      link.download = fileName; // Kullanıcının indireceği dosya adı
      link.click();

      // URL'yi serbest bırak
      URL.revokeObjectURL(url);
    } else {
      console.error("Geçersiz Base64 verisi:", pdfData);
      alert("Geçersiz PDF verisi.");
    }
  };

  const handleDeleteUser = async () => {
    try {
      setLoading(true); // Silme işlemi başlatılıyor
      await axios.delete("https://kariyer.biyomed.net/api/user/deleteUser", {
        withCredentials: true, // Cookie gönderimi için
      });
      alert("Hesabınız başarıyla silindi.");
      await logout(loginType);
      window.location.href = "/"; // Ana sayfaya yönlendirme
    } catch (error) {
      console.error("Hesap silme işlemi başarısız:", error);
      alert("Hesap silme işlemi başarısız. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false); // Yükleniyor durumu bitiyor
      setOpenDialog(false); // Dialog kapanıyor
    }
  };

  // const handleOpenDialog = () => {
  //   setOpenDialog(true); // Dialog açılıyor
  // };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Dialog kapanıyor
  };

  // Link basinda https yoksa tamamlar
  const withProtocol = (url) =>
    url && !url.startsWith("http") ? `https://${url}` : url;

  // Bilgi satiri: deger yoksa "Belirtilmemis" gosterir
  const InfoItem = ({ label, value, wide = false }) => (
    <div className={`bm-info-item${wide ? " bm-info-item--wide" : ""}`}>
      <span className="bm-info-label">{label}</span>
      <div className={`bm-info-value${value ? "" : " bm-info-value--empty"}`}>
        {value || "Belirtilmemiş"}
      </div>
    </div>
  );

  // Belge satiri: indir butonu ya da "mevcut degil"
  const DocItem = ({ label, data, fileName, wide = false }) => (
    <div className={`bm-info-item${wide ? " bm-info-item--wide" : ""}`}>
      <span className="bm-info-label">{label}</span>
      <div className="bm-info-value">
        {data ? (
          <Button
            variant="outlined"
            size="small"
            color="primary"
            onClick={() => handleDownload(data, fileName)}
            startIcon={<FaFilePdf />}
            sx={{ textTransform: "none", borderRadius: "10px" }}
          >
            Belgeyi indir
          </Button>
        ) : (
          <span className="bm-info-value--empty">Mevcut değil</span>
        )}
      </div>
    </div>
  );

  return (
    <div className="bm-page">
      <div className="bm-container">
        <div className="bm-page-head">
          <h1 className="bm-page-title">Profilim</h1>
          <p className="bm-page-sub">
            Kayıt ve detay bilgilerinizi buradan görüntüleyip düzenleyebilirsiniz.
          </p>
        </div>

        <div className="bm-profile-grid">
          {/* Sol kolon: avatar, sosyal linkler, eylemler */}
          <div>
            <div className="bm-card">
              <div className="bm-profile-hero">
                <div className="bm-profile-cover" />
                <img
                  className="bm-avatar"
                  src={
                    user.profile_image
                      ? user.profile_image
                      : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                  }
                  alt="profile_img"
                />
                <h2 className="bm-profile-name">
                  {user.first_name || user.last_name
                    ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
                    : "Kullanıcı"}
                </h2>
                {user.email ? (
                  <p className="bm-profile-meta">{user.email}</p>
                ) : null}

                {user.profile_link1 || user.profile_link2 ? (
                  <ul className="bm-social">
                    {user.profile_link1 ? (
                      <li>
                        <a
                          href={withProtocol(user.profile_link1)}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="LinkedIn"
                        >
                          <i className="fa fa-linkedin" />
                        </a>
                      </li>
                    ) : null}
                    {user.profile_link2 ? (
                      <li>
                        <a
                          href={withProtocol(user.profile_link2)}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Web sitesi"
                        >
                          <i className="fa fa-globe" />
                        </a>
                      </li>
                    ) : null}
                  </ul>
                ) : null}
              </div>

              <div className="bm-card-body" style={{ paddingTop: 0 }}>
                <ul className="bm-action-list">
                  <li>
                    <a
                      href={
                        userDetailsIsFilled
                          ? "/update-user-details"
                          : "/user-details"
                      }
                    >
                      <i className="fa fa-pencil" />
                      {userDetailsIsFilled
                        ? "Detay Bilgilerini Düzenle"
                        : "Profili Oluştur"}
                    </a>
                  </li>
                  {/* <li>
                    <a onClick={handleOpenDialog}>
                      Hesabı Sil
                    </a>
                  </li> */}
                  <li>
                    <a href="/update-user-info">
                      <i className="fa fa-id-card-o" />
                      Kayıt Bilgilerini Düzenle
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Sag kolon: detay bilgileri */}
          <div>
            {userDetailsIsFilled ? (
              <>
                <div className="bm-card">
                  <div className="bm-card-head">
                    <span className="bm-card-badge">
                      <i className="fa fa-user" />
                    </span>
                    <h3>Kişisel Bilgiler</h3>
                  </div>
                  <div className="bm-card-body">
                    <div className="bm-info-list">
                      <InfoItem label="Ad" value={user?.first_name} />
                      <InfoItem label="Soyad" value={user?.last_name} />
                      <InfoItem label="E-posta" value={user?.email} />
                      <InfoItem label="Telefon" value={user?.phone} />
                      <InfoItem label="Şehir" value={user?.residence_city} />
                      <InfoItem label="İş Durumu" value={user?.job_status} />
                      <InfoItem
                        label={
                          user.user_type === "Mezun"
                            ? "Mezuniyet Yılı"
                            : "Tahmini Mezuniyet Yılı"
                        }
                        value={user?.graduation_year}
                      />
                      <InfoItem
                        label="Diller"
                        value={user?.languages
                          ?.replace(/\./g, " ")
                          .replace(/,/g, ", ")}
                      />
                      <div className="bm-info-item bm-info-item--wide">
                        <span className="bm-info-label">Profil Linki</span>
                        <div
                          className={`bm-info-value${
                            user?.profile_link1 ? "" : " bm-info-value--empty"
                          }`}
                        >
                          {user?.profile_link1 ? (
                            <a
                              href={withProtocol(user.profile_link1)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {user.profile_link1}
                            </a>
                          ) : (
                            "Belirtilmemiş"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bm-card">
                  <div className="bm-card-head">
                    <span className="bm-card-badge">
                      <i className="fa fa-file-text-o" />
                    </span>
                    <h3>Belgeler</h3>
                  </div>
                  <div className="bm-card-body">
                    <div className="bm-info-list">
                      <DocItem
                        label="Türkçe Özgeçmiş"
                        data={user.cv_turkish}
                        fileName={`${user.first_name}_cv_turkish.pdf`}
                      />
                      <DocItem
                        label="İngilizce Özgeçmiş"
                        data={user.cv_english}
                        fileName={`${user.first_name}_cv_english.pdf`}
                      />
                      <DocItem
                        label="Mezuniyet/Öğrenci Belgesi"
                        data={user.graduation_document}
                        fileName={`${user.first_name}_graduation_document.pdf`}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="bm-card">
                <div className="bm-card-body">
                  <Alert severity="success" sx={{ borderRadius: "12px" }}>
                    <AlertTitle>Kayıt Onaylandı</AlertTitle>
                    Kaydınız başarıyla onaylanmıştır. Lütfen{" "}
                    <strong>Profili Oluştur</strong> butonuna basarak detay
                    bilgilerinizi girerek kaydınızı tamamlayınız.
                  </Alert>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Dialog for Account Deletion */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Hesabı Silme Onayı</DialogTitle>
        <DialogContent>
          <p>
            Hesabınızı silerseniz basvurdugunuz ilanlar ve bilgileriniz tamamen
            silinecektir. Onaylıyor musunuz?
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Vazgeç
          </Button>
          <Button onClick={handleDeleteUser} color="error" disabled={loading}>
            {loading ? "Siliniyor..." : "Evet, Sil!"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserProfile;
